import { render, staticRenderFns } from "./MetricsCountMembers.vue?vue&type=template&id=55021921"
import script from "./MetricsCountMembers.vue?vue&type=script&lang=js"
export * from "./MetricsCountMembers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports